import { PartialObserver, Subject, Subscription } from 'rxjs';

export class QueueSubject<T = unknown> extends Subject<T> {
  private itemList: T[] = [];

  public next(item: T) {
    if (this.observers.length > 0) {
      super.next(item);
    } else {
      this.itemList.push(item);
    }
  }

  public subscribe(observer: PartialObserver<T>): Subscription;

  public subscribe(
    next: (value: T) => void,
    error?: (err: unknown) => void,
    complete?: () => void,
  ): Subscription;

  public subscribe(...args: never[]): never;

  public subscribe(
    nextOrObserver: ((value: T) => void) | PartialObserver<T>,
    error?: (err: unknown) => void,
    complete?: () => void,
  ) {
    let subscription: Subscription;
    if (typeof nextOrObserver === 'function') {
      subscription = super.subscribe(nextOrObserver, error, complete);
    } else {
      subscription = super.subscribe(nextOrObserver);
    }
    this.itemList.forEach((item) => this.next(item));
    this.itemList = [];
    return subscription;
  }
}
